import PropTypes from 'prop-types';
import {Submit as ButtonMore, Link} from 'ui';
import {Container, ArticleCover, Image, BackLink, MainTitle, Mask} from 'scenes/article/styles';
import {Paragraph} from 'scenes/article/articleParagraph/styles';
import {Content, Level, Video, SectionTitle, Steps, Step, StepNumber, StepImage, Print} from './styles';

// Les contenus WordPress gardent des paragraphes vides (« &nbsp; ») qui creusent la page.
const withoutEmptyParagraphs = html => (html || '').replace(/<p>(\s|&nbsp;|\u00A0)*<\/p>/g, '');

// Geste technique (type WordPress « conseils »), affiché comme sur sa page du site.
const BaseConseil = ({history, data}) => {
  const {
    conseils_image,
    conseils_video,
    conseils_niveau,
    conseils_etapes,
    conseils_besoins,
    conseils_document_pdf,
  } = data.acf || {};
  const video = (conseils_video || '').trim();
  const steps = Array.isArray(conseils_etapes) ? conseils_etapes : [];

  return (
    <Container>
      <ArticleCover>
        <Image src={conseils_image} />
        <BackLink to="/recipes" />
        {/* eslint-disable-next-line react/no-danger */}
        <MainTitle dangerouslySetInnerHTML={{__html: data.title.rendered}} />
        <Mask />
      </ArticleCover>

      <Content>
        {/* eslint-disable-next-line react/no-danger */}
        <Paragraph dangerouslySetInnerHTML={{__html: withoutEmptyParagraphs(data.content.rendered)}} />
        {conseils_niveau && <Level>Niveau&nbsp;: {conseils_niveau}</Level>}

        {video && (
          <Video>
            <iframe
              src={`https://www.youtube.com/embed/${encodeURIComponent(video)}`}
              frameBorder="0"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowFullScreen
              title={data.title.rendered.replace(/<[^>]*>/g, '')}
            />
          </Video>
        )}

        {/* eslint-disable-next-line react/no-danger */}
        {conseils_besoins && (
          <Paragraph dangerouslySetInnerHTML={{__html: withoutEmptyParagraphs(conseils_besoins)}} />
        )}

        {steps.length > 0 && (
          <>
            <SectionTitle>Les étapes</SectionTitle>
            <Steps>
              {steps.map((step, index) => (
                // eslint-disable-next-line react/no-array-index-key
                <Step key={index}>
                  <StepNumber>{index + 1}</StepNumber>
                  <div>
                    {step.conseils_etapes_texte}
                    {step.conseils_etapes_image && <StepImage src={step.conseils_etapes_image} alt="" />}
                  </div>
                </Step>
              ))}
            </Steps>
          </>
        )}

        {conseils_document_pdf && (
          <Print>
            <Link href={conseils_document_pdf} target="_blank" rel="noopener noreferrer">
              Télécharger la fiche (PDF)
            </Link>
          </Print>
        )}
      </Content>

      <ButtonMore onClick={() => history.push('/recipes')}>Voir toutes les recettes</ButtonMore>
    </Container>
  );
};

BaseConseil.propTypes = {
  data: PropTypes.object.isRequired,
  history: PropTypes.object.isRequired,
};

export default BaseConseil;
